<button mat-button (click)="openDialog()">+ Projekt</button>

